import { FormProvider } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { useAddBuilderParticipantToReception } from "../../../../api/mutations/constructionSiteSubmission.mutations";
import { BuilderToReceptionForm } from "../../../../component/constructionSites/submission/participants/BuilderToReceptionForm";
import PageLayoutWithTabs from "../../../../component/layout/PageLayoutWithTabs";
import { useBuilderToReceptionForm } from "./useParticipantToReceptionForm";

const AddBuilderReceptionPage = () => {
	const navigate = useNavigate();
	const { constructionSiteId } = useParams<{ constructionSiteId: string }>();

	function goBack() {
		navigate(-1);
	}

	const numericConstructionSiteId = constructionSiteId
		? Number(constructionSiteId)
		: 0;

	const addBuilder = useAddBuilderParticipantToReception(
		numericConstructionSiteId,
	);

	const formApi = useBuilderToReceptionForm({
		mode: "add",
		onSubmit: (data) => addBuilder.mutate(data, { onSuccess: () => goBack() }),
	});

	if (!constructionSiteId) return null;

	return (
		<PageLayoutWithTabs title="Ajouter un réalisateur">
			<FormProvider {...formApi.form}>
				<form onSubmit={formApi.handleSubmit}>
					<BuilderToReceptionForm
						constructionSiteId={numericConstructionSiteId}
						onSubmit={formApi.handleSubmit}
						onCancel={goBack}
						isSubmitting={addBuilder.isPending}
					/>
				</form>
			</FormProvider>
		</PageLayoutWithTabs>
	);
};

export default AddBuilderReceptionPage;
